import React, { useState, useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import get from "loadsh/get";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import styles from "../styles/Home.module.css";
import TopSection from "../components/Home/TopSection";
import HowItWorks from "../components/Home/HowItWorks";
import FeaturedSongs from "../components/Home/FeaturedSongs";
import OurPartners from "../components/Home/OurPartners";
import JoinCommunity from "../components/Home/JoinCommunity";
import ArtistSubmission from "../components/Home/ArtistSubmission";
import Footer from "../components/Home/Footer";
import Layout from "../components/Layout/Layout";
import { NextSeo } from "next-seo";

import FollowUs from "../components/Home/FollowUs";
import { setInviteCode } from "../src/redux/slices/home";
import fetcher from "../src/dataProvider";
import JoinEarlyAccess from "../components/Home/JoinEarlyAccess";
import InTheNews from "../components/Home/InTheNews";
import WatchVideos from "../components/Home/WatchVideos";
import FAQs from "../components/Home/FAQs";
import Router from "next/router";
import {
  STRAPI_API_URL,
  DISPLAY_SONG_PAGE,
} from "../src/constant/appConstants";
import auth from "../components/Layout/util/auth";
import Spinner from "../components/Common/Spinner";
import ReferAndEarn from "../components/Home/ReferAndEarn";
import { Box } from "@mui/material";
import AppDownload from "../components/Home/AppDownload";

export async function getStaticProps() {
  let url = STRAPI_API_URL + "/artist-assets/1?populate=*";
  let data;
  try {
    const res = await fetch(
      `${STRAPI_API_URL}/frontend-configs?filters[slug][$eq]=home`
    );
    const data1 = await res.json();
    data = data1.data;

    const featureSong = await fetcher.get(`${STRAPI_API_URL}/artist-assets`, {
      params: {
        [`filters[upcoming_homepage][$eq]`]: "true",
        populate: "*",
      },
    });
    const featureSongdata = featureSong.data;

    return {
      props: {
        data,
        url,
        featureSongdata,
        API_URL: STRAPI_API_URL,
      },
      revalidate: 10,
    };
  } catch (error) {
    // The  API most likely died
    console.error(error);
    return {
      props: {
        url,
        API_URL: STRAPI_API_URL,
        error: JSON.stringify(error),
      },
      revalidate: 10, // In seconds
    };
  }
}

export default function Home(props) {
  const featureSongvalue = props.featureSongdata;
  let keyValue = new Map();
  props?.data?.forEach((item) => {
    keyValue.set(item.attributes.key, item.attributes.value);
  });

  const [isEarlyaccess, setIsEarlyaccess] = useState(false);
  const [isCommunityAccess, setIsCommunityAccess] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    fetch(`${STRAPI_API_URL}/app-configs?populate=*&filters[id][$eq]=5`)
      .then((r) => {
        return r.json();
      })
      .then((data) => {
        if (data.data[0].attributes.config_value == 1) {
          setIsEarlyaccess(true);
        } else if (data.data[0].attributes.config_value == 2) {
          setIsCommunityAccess(true);
        }
      });
  }, []);

  useEffect(() => {
    const inviteCode = get(router, "query.ic");
    if (inviteCode != undefined) {
      dispatch(setInviteCode(inviteCode));
      localStorage.setItem("inviteCode", inviteCode);
    }
  }, [router]);

  const r = auth();

  useEffect(() => {
    if (!r.email) {
      setIsLogin(true);
    }
  }, [r]);

  return (
    <Box>
      {/* <NextSeo
        title={keyValue.get("title")}
        
        description={keyValue.get("title")}
        canonical="https://fantiger.com/"
        openGraph={{
          title:
            "Hold your seat belts tights. FanTiger is going to Take Off...",
          description:
            "Join the waitlist for early access and refer 	your friends for a chance at being part of an exclusive airdrop.",
          type: "website",
          url: "https://fantiger.com/",
          images: [
            {
              url: "https://fantiger.com/images/home/fantiger-logo.png",
            },
          ],
          site_name: "FanTiger Waitlist",
        }}
      /> */}
      <Head>
        <title>FanTiger - Invest in Songs</title>
        <meta
          name="description"
          content="Earn Royalty Income and Privileges On FanTiger"
        />

        <meta name="name" content="FanTiger - Invest in Songs" />
        <meta
          name="image"
          content="https://d2q23p4t0ij9e0.cloudfront.net/small_referal_1ee3ed7a49.png"
        />

        <meta property="og:url" content={process.env.NEXT_PUBLIC_WEB_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="FanTiger - Invest in Songs" />
        <meta
          property="og:description"
          content="Earn Royalty Income and Privileges On FanTiger"
        />
        <meta
          property="og:image"
          content="https://d2q23p4t0ij9e0.cloudfront.net/small_referal_1ee3ed7a49.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FanTiger - Invest in Songs" />
        <meta
          name="twitter:description"
          content="Earn Royalty Income and Privileges On FanTiger"
        />
        <meta
          name="twitter:image"
          content="https://d2q23p4t0ij9e0.cloudfront.net/small_referal_1ee3ed7a49.png"
        />
      </Head>
      <div className={styles.container}>
        {/* <Head>
        <title> {keyValue.get("title")} </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />

        
        <meta
          property="og:image"
          content="https://stg1.artistfirst.in/images/home/fantiger-logo.png"
        />
 

        <link rel="icon" href="/favicon.ico" />
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin></link>
      </Head> */}
        <Layout color="#0c083b" borderBottom="none">
          {/* <div className={classes.loader}>
            <Spinner/>
          </div> */}
          {isEarlyaccess ? (
            <div>{/* <h1>EarlyAccess page</h1> */}</div>
          ) : (
            <div></div>
          )}
          <TopSection data={keyValue} featureSong={featureSongvalue} />
          {/* <JoinEarlyAccess data={keyValue} /> */}
          {/* <UpcomingSong data={keyValue} /> */}

          {/* {isLogin || process.env.NEXT_PUBLIC_PAYMENT_ENABLED=="false" || process.env.NEXT_PUBLIC_PAYMENT_ENABLED==false ? (
            <> </>
          ) : (

            <FeaturedSongs
              data={keyValue}
              featureSongvalue={featureSongvalue}
            />

          )} */}

          <FeaturedSongs data={keyValue} featureSong={featureSongvalue} />

          {/* <JoinEarlyAccess data={keyValue} /> */}
          <ReferAndEarn data={keyValue} />
          <HowItWorks data={keyValue} />
          <AppDownload data={keyValue} />
          <FAQs data={keyValue} />
          <InTheNews data={keyValue} />
          <WatchVideos data={keyValue} />
          <JoinCommunity data={keyValue} />

          <ArtistSubmission data={keyValue} />
          <OurPartners data={keyValue} />
          <FollowUs data={keyValue} />
        </Layout>
        <Footer />
      </div>
    </Box>
  );
}
